"use client"

import React from 'react';
import Button from './Button';

import getRealBBox from './../utils/getRealBBox';
import __ from './../utils/translation';

import { ReactComponent as IconAlignLeft } from './../icons/align-left.svg';
import { ReactComponent as IconAlignCenterH } from './../icons/align-center-h.svg';
import { ReactComponent as IconAlignRight } from './../icons/align-right.svg';
import { ReactComponent as IconAlignTop } from './../icons/align-top.svg';
import { ReactComponent as IconAlignCenterV } from './../icons/align-center-v.svg';
import { ReactComponent as IconAlignBottom } from './../icons/align-bottom.svg';

import { Card, CardContent } from './ui/card';
import { Button as ShadcnButton } from './ui/button';

const SelectionAlignSettings = ({ canvas, activeSelection }) => {

  const alignObject = (pos) => {
    switch (pos){
      case 'left':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set('left', (activeSelection.left - bound.left - realBound.x1))
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      case 'center-h':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set(
            'left',
            (activeSelection.left - bound.left - realBound.x1) + (canvas.originalW / 2) - (realBound.width / 2)
          )
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      case 'right':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set('left', (activeSelection.left - bound.left - realBound.x1) + canvas.originalW - realBound.width)
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      case 'top':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set('top', (activeSelection.top - bound.top - realBound.y1))
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      case 'center-v':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set(
            'top',
            (activeSelection.top - bound.top - realBound.y1) + (canvas.originalH / 2) - (realBound.height / 2)
          )
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      case 'bottom':

        (async () => {
          let bound = activeSelection.getBoundingRect(true)
          let realBound = await getRealBBox(activeSelection)
          activeSelection.set(
            'top',
            (activeSelection.top - bound.top - realBound.y1) + (canvas.originalH - realBound.height)
          )
          activeSelection.setCoords()
          canvas.renderAll()
          canvas.trigger('object:modified')
        })()

        break

      default:
        break
    }
  }


  return (
    <Card className="border-0 shadow-none bg-background p-2 h-10">
      <CardContent className="p-0 space-y-4">
        <div id="aligment-options">
          <ShadcnButton 
            id="fit-obj-canvas" 
            variant="outline" 
            className="w-full h-6 font-medium text-sm"
          >
            {__('ENCAIXAR NO CANVAS')}
          </ShadcnButton>
        </div>
      </CardContent>
    </Card>
  )
}

export default SelectionAlignSettings
